export const aboutKeys = {
  hero: {
    badge: "about:hero:badge",
    title: "about:hero:title",
    subtitle: "about:hero:subtitle",
    ctaPrimary: "about:hero:ctaPrimary",
    ctaSecondary: "about:hero:ctaSecondary",
  },

  sections: {
    statsTitle: "about:sections:statsTitle",
    storyTitle: "about:sections:storyTitle",
    valuesTitle: "about:sections:valuesTitle",
    milestonesTitle: "about:sections:milestonesTitle",
    teamTitle: "about:sections:teamTitle",
    finalLead: "about:sections:finalLead",
    finalBtn: "about:sections:finalBtn",
  },

  stats: [
    { label: "about:stats:years", value: "25+" },
    { label: "about:stats:turnaround", value: "24 hrs" },
    { label: "about:stats:colourAccuracy", value: "99.9 %" },
    { label: "about:stats:printingCapacity", value: "600–700 m/hr" },
  ],

  values: [
    { title: "about:values:craft:title", text: "about:values:craft:text" },
    {
      title: "about:values:reliability:title",
      text: "about:values:reliability:text",
    },
    { title: "about:values:service:title", text: "about:values:service:text" },
  ],

  story: {
    lead: "about:story:lead",
  },
} as const;
